
import { Component, Provide, Vue, Watch, Mixins, InjectReactive, ProvideReactive } from "vue-property-decorator";
// api
import { Userinfo } from "@/types/store";
import { Menu, MenuChild, EditableTabs } from "@/types/views";
import { loginOut, adminInfo } from "@/api/login";
// 组件
import Submenu from "./components/Submenu.vue";
import Content from "./components/Content.vue";
// 工具
import print from "@/utils/print";
import copy from "@/utils/deepCopy";

import { routes } from "@/router/index";

@Component({
  inject: [],
  components: {
    Submenu,
    Content,
  },
})
export default class Home extends Vue {
  @ProvideReactive() HomeInstance = this;

  /**
   * data
   */
  isCollapse: boolean = false;
  editableTabsValue: string = "home";
  editableTabs: Array<EditableTabs> = [];
  descripbeName: string = "";
  /** 最大 tab 数量，超出时自动关闭最左侧非 active 的 tab */
  readonly MAX_TABS = 15;
  /** 控制 router-view 显隐，用于刷新当前 tab */
  routerAlive: boolean = true;
  /**
   * README: keep-alive 缓存列表，动态维护已打开页面的组件 name
   * 组件 name 由 build/vue-name-loader.js 在编译阶段自动注入（基于文件路径）
   */
  cachedViews: string[] = [];
  /**
   * README: tab name（路由 path）→ 组件 name 的映射，用于关闭 tab 时精确清理缓存
   */
  routeToComponent: Record<string, string> = {};

  /**
   * 生命周期
   */
  mounted() {
    this.HomeInstance = this;
    adminInfo().then((res) => {
      this.$store.dispatch("setUserinfo", res.data);
    });
  }

  /**
   * computed计算
   */
  get menus(): any {
    return this.$store.getters.userinfo.menus;
  }

  get activeMenu(): string {
    let index = this.$route.path.replace("/", "");
    this.editableTabsValue = index;
    // README: 尽量不要在get 里面做set 操作，半天没找到;
    this.addTab(index,this.$route.fullPath);
    return index;
  }

  /**
   * watch监听
   */
  @Watch("$route", { immediate: true })
  routechange(to: any, from: any) {
    // 查看是否登录
    this.addCacheView(to);
  }

  /**
   * README: 从已解析的路由组件中获取组件 name，加入 keep-alive 缓存列表。
   * keep-alive 匹配的是组件自身的 name（由 vue-name-loader 注入），不是路由的 name（中文）。
   */
  addCacheView(route: any) {
    const matched = route.matched;
    const lastMatched = matched[matched.length - 1];
    if (!lastMatched?.components?.default) return;

    const comp = lastMatched.components.default;
    // vue-name-loader 在编译时已注入 name，这里直接读取
    const componentName: string | undefined = comp.options?.name;

    if (!componentName) return;

    // 记录 tab name → 组件 name 的映射
    // tab name 由 addTab 生成，格式为路由 path 去掉前缀 "/"（如 "storeList"）
    // 所以这里也用同样格式作为 key，不能用 route.name（中文标题）
    const tabName = route.path.replace(/^\//, '');
    if (tabName) {
      this.routeToComponent[tabName] = componentName;
    }

    // 去重加入缓存列表
    if (!this.cachedViews.includes(componentName)) {
      this.cachedViews.push(componentName);
    }
  }

  /**
   * methods方法
   */
  // 添加tab
  addTab(name: string,fullPath:string) {
    let tit = "";
    this.menus.map((item: Menu): void => {
      if (item.children && item.children.length > 0) {
        item.children.map((e: MenuChild): void => {
          if (e.name == name) {
            tit = e.title;
          }
        });
      } else {
          if (item.name == name) {
            tit = item.title;
          }
      }
    });
    // 这里会有个情况就是路由接口还没加载好
    if (!tit) {
      const list = routes?.find(el => el.path == "/layout")?.children;
      tit = list.find((el) => el.path.replace("/", "") == name)?.name;
    }
    this.descripbeName = tit;

    if (this.editableTabs.find((e) => e.name == name)){
        this.editableTabs.forEach((e)=>{
            if(e.name == name){
              e.fullPath = fullPath;
            }
        });
    }else{
         this.editableTabs.push({
          title: tit,
          name: name,
          fullPath:fullPath
        });
        // 超出上限时，关闭最左侧非 active 的 tab
        this.trimTabs();
    }

  }

  /** 超出 MAX_TABS 上限时，关闭最左侧非 active 的 tab */
  trimTabs() {
    while (this.editableTabs.length > this.MAX_TABS) {
      // 找到第一个非当前 active 的 tab
      const idx = this.editableTabs.findIndex(t => t.name !== this.editableTabsValue);
      if (idx < 0) break;
      const removed = this.editableTabs[idx];
      this.editableTabs.splice(idx, 1);
      this.removeCacheView(removed.name);
    }
  }

  // 选中tab
  tabClick(tab: any): void {
    this.editableTabsValue = tab.name;
    this.descripbeName = tab.label;
    this.$router.replace({
      path:tab.$attrs['path']
    });
  }
  // 删除tab
  tabRemove(targetName: string) {
    let tabs = this.editableTabs;
    let activeName = this.editableTabsValue;
    let activePath = '';
    if (activeName === targetName) {
      tabs.forEach((tab: any, index: number) => {
        if (tab.name === targetName) {
          let nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            //  选中上一个tab
            activeName = nextTab.name;
            activePath = nextTab.fullPath
          }
        }
      });
    }
    //  回到上一个tab
    this.editableTabsValue = activeName;
    this.editableTabs = this.editableTabs.filter((e) => e.name != targetName);
    let temIndex = this.editableTabs.findIndex(
      (e: EditableTabs) => e.name == activeName
    );
    temIndex > 0
      ? (this.descripbeName = this.editableTabs[temIndex].title)
      : null;

    // README: 清理 keep-alive 缓存，当没有其他 tab 使用同一组件时才移除
    this.removeCacheView(targetName);

    // 至少留一个tab
    activeName == targetName ? null : this.$router.replace({
      path:activePath
    });
  }

  /**
   * README: 关闭 tab 时清理对应的 keep-alive 缓存
   * 需要检查是否有其他 tab 仍在使用同一组件（如 appCompose 和 merchantAppCompose 共用组件）
   */
  removeCacheView(tabName: string) {
    const componentName = this.routeToComponent[tabName];
    if (!componentName) return;

    // 检查是否还有其他 tab 使用同一组件
    const hasOtherTab = this.editableTabs.some(
      tab => tab.name !== tabName && this.routeToComponent[tab.name] === componentName
    );

    if (!hasOtherTab) {
      this.cachedViews = this.cachedViews.filter(v => v !== componentName);
    }

    delete this.routeToComponent[tabName];
  }

  // ========== 批量关闭 tab（右键菜单） ==========

  /** 批量关闭指定 tab 列表，targetTabName 为保留并切换到的 tab */
  batchCloseTabs(tabsToClose: EditableTabs[], targetTabName: string) {
    if (!tabsToClose.length) return;

    // 逐个清理缓存
    tabsToClose.forEach(tab => this.removeCacheView(tab.name));

    // 批量移除
    const closeNames = new Set(tabsToClose.map(t => t.name));
    this.editableTabs = this.editableTabs.filter(t => !closeNames.has(t.name));

    // 如果当前 active tab 被关闭，切换到 target
    if (closeNames.has(this.editableTabsValue)) {
      this.editableTabsValue = targetTabName;
      const targetTab = this.editableTabs.find(t => t.name === targetTabName);
      if (targetTab) {
        this.descripbeName = targetTab.title;
        this.$router.replace({ path: targetTab.fullPath });
      }
    }
  }

  /** 关闭左侧 tab */
  closeLeftTabs(tabName: string) {
    const idx = this.editableTabs.findIndex(t => t.name === tabName);
    if (idx <= 0) return;
    const tabsToClose = this.editableTabs.slice(0, idx);
    this.batchCloseTabs(tabsToClose, tabName);
  }

  /** 关闭右侧 tab */
  closeRightTabs(tabName: string) {
    const idx = this.editableTabs.findIndex(t => t.name === tabName);
    if (idx < 0 || idx >= this.editableTabs.length - 1) return;
    const tabsToClose = this.editableTabs.slice(idx + 1);
    this.batchCloseTabs(tabsToClose, tabName);
  }

  /** 关闭其他 tab */
  closeOtherTabs(tabName: string) {
    const tabsToClose = this.editableTabs.filter(t => t.name !== tabName);
    this.batchCloseTabs(tabsToClose, tabName);
  }

  /** 刷新指定 tab：清除缓存并重新渲染 */
  refreshTab(tabName: string) {
    const componentName = this.routeToComponent[tabName];
    if (!componentName) return;

    // 从缓存中移除该组件
    this.cachedViews = this.cachedViews.filter(v => v !== componentName);

    if (tabName === this.editableTabsValue) {
      // 刷新当前 tab：通过 v-if 销毁并重建 router-view
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
        this.cachedViews.push(componentName);
      });
    } else {
      // 刷新其他 tab：仅清除缓存，下次切换过去时会自动重新创建
      this.$nextTick(() => {
        this.cachedViews.push(componentName);
      });
    }
  }
  // 退出登录
  handleCommand(i: any) {
    if (parseInt(i) == 1) {
      this.$confirm("是否要退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        loginOut().then((res) => {
          localStorage.removeItem("yysj_token");
          this.$store.dispatch("setToken", "");
          this.$router.replace("login");
        });
        this.$router.replace("login");
      });
    } else {
      this.$confirm("修改密码，请联系客服", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {})
        .catch((err) => {});
    }
  }
  changeTabs(val: string) {
    this.editableTabsValue = val;
  }
}
